(() => {
  const root = document.querySelector('[data-mello-page]');
  if (!root) return;

  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const shell = root.querySelector('[data-cart-shell]');
  const itemsEl = root.querySelector('[data-cart-items]');
  const footerEl = root.querySelector('[data-cart-footer]');
  const countEls = document.querySelectorAll('[data-cart-count]');
  const totalEl = root.querySelector('[data-cart-total]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const form = root.querySelector('[data-product-form]');
  const status = root.querySelector('[data-form-status]');

  const openCart = () => {
    shell.hidden = false;
    document.body.classList.add('is-cart-open');
    shell.querySelector('.mello-cart').focus?.();
  };
  const closeCart = () => {
    shell.hidden = true;
    document.body.classList.remove('is-cart-open');
  };

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart.');
    return response.json();
  }

  function renderCart(cart) {
    countEls.forEach((el) => { el.textContent = cart.item_count; });
    const headerCount = document.querySelector('[data-header-cart-count]');
    if (headerCount) headerCount.textContent = cart.item_count;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="mello-cart__empty"><p>Your cart is ready for a little ritual.</p><button class="mello-continue" type="button" data-cart-close>Continue shopping</button></div>';
      footerEl.hidden = true;
      return;
    }
    itemsEl.innerHTML = cart.items.map((item, index) => `
      <article class="mello-cart__item">
        <img src="${item.image || ''}" alt="${item.product_title.replace(/"/g, '&quot;')}">
        <div>
          <h3>${item.product_title}</h3>
          <p>${item.variant_title || ''}</p>
          <div class="mello-cart__qty" aria-label="Quantity">
            <button type="button" data-cart-change="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <strong class="mello-cart__price">${money(item.final_line_price)}</strong>
      </article>`).join('');
    totalEl.textContent = money(cart.total_price);
    footerEl.hidden = false;
  }

  async function refreshCart(shouldOpen = false) {
    try {
      renderCart(await fetchCart());
      if (shouldOpen) openCart();
    } catch (error) {
      if (status) status.textContent = error.message;
    }
  }

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const id = new FormData(form).get('id');
    if (!id) return;
    button.disabled = true;
    status.textContent = 'Adding to your cart…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('This item could not be added right now.');
      status.textContent = 'Added to your cart.';
      await refreshCart(true);
    } catch (error) {
      status.textContent = error.message;
    } finally {
      button.disabled = false;
    }
  });

  root.addEventListener('click', async (event) => {
    const close = event.target.closest('[data-cart-close]');
    if (close) { closeCart(); return; }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      change.disabled = true;
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(change.dataset.cartChange), quantity: Number(change.dataset.quantity) })
        });
        if (!response.ok) throw new Error('Unable to update cart.');
        renderCart(await response.json());
      } catch (error) {
        if (status) status.textContent = error.message;
      }
      return;
    }
    const mobileAdd = event.target.closest('[data-mobile-add]');
    if (mobileAdd) form?.requestSubmit();
  });

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async (event) => {
    event.preventDefault();
    await refreshCart(true);
  }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !shell.hidden) closeCart(); });

  root.querySelectorAll('.mello-variant input').forEach((input) => input.addEventListener('change', () => {
    root.querySelectorAll('.mello-variant').forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
    const label = input.closest('.mello-variant');
    const priceText = label.querySelector('.mello-variant__top b')?.textContent.trim();
    const addLabel = form.querySelector('[data-add-label]');
    if (priceText && addLabel) addLabel.textContent = `Add to cart — ${priceText}`;
    if (priceText && mobilePrice) mobilePrice.textContent = priceText;
  }));

  const mainImage = root.querySelector('[data-gallery-main]');
  const stage = mainImage?.closest('.mello-gallery__stage');
  root.querySelectorAll('[data-gallery-src]').forEach((thumb) => thumb.addEventListener('click', () => {
    if (!mainImage || thumb.classList.contains('is-active')) return;
    root.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
    stage.classList.add('is-changing');
    const next = new Image();
    next.onload = () => { mainImage.src = next.src; setTimeout(() => stage.classList.remove('is-changing'), 60); };
    next.src = thumb.dataset.gallerySrc;
  }));

  const reveals = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.12, rootMargin: '0px 0px -40px' });
    reveals.forEach((element, index) => { element.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`; observer.observe(element); });
  } else reveals.forEach((element) => element.classList.add('is-visible'));

  const hero = root.querySelector('.mello-product-form');
  const mobileBar = root.querySelector('[data-mobile-bar]');
  if (hero && mobileBar && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => mobileBar.classList.toggle('is-hidden', entry.isIntersecting), { threshold: .2 }).observe(hero);
  }

  refreshCart(false);
})();
